module.exports = __webpack_public_path__ + "img/type_container-chassis.210d13bf.jpg";